import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const KOLEKTIF_GROUPS = [
  {
    name: "Kolektif Gençlik",
    logo: "/logos/kolektif-genclik.jpeg",
    href: "/ekibimiz/kolektif-genclik",
    scale: 1.0,
  },
  {
    name: "Kolektif Avrupa",
    logo: "/logos/kolektif-avrupa.jpeg",
    href: "/ekibimiz/kolektif-avrupa",
    scale: 1.15,
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

const KolektifGroups = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 tracking-wide">
            Kolektif Gruplarımız
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto">
            Farklı alanlarda faaliyet gösteren gruplarımızla geniş bir öğrenci
            ağı oluşturuyoruz.
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 items-center justify-items-center"
        >
          {KOLEKTIF_GROUPS.map((group) => (
            <Link to={group.href} key={group.name}>
              <motion.div
                key={group.name}
                variants={item}
                className="group flex flex-col items-center transition-all duration-300 cursor-pointer"
              >
                <div className="w-52 h-52 relative mb-8 flex items-center justify-center transform transition-all duration-300 group-hover:scale-105 overflow-hidden rounded-full">
                  <div className="absolute inset-0 bg-blue-500/20 rounded-full blur-xl group-hover:bg-blue-500/30 transition-all duration-300" />
                  <div className="w-full h-full bg-black flex items-center justify-center rounded-full ring-2 ring-white/10 group-hover:ring-white/20 transition-all duration-300">
                    <img
                      src={group.logo}
                      alt={`${group.name} Logo`}
                      className="w-full h-full object-contain mix-blend-screen"
                      style={{
                        transform: `scale(${group.scale})`,
                      }}
                    />
                  </div>
                </div>
                <h3 className="text-2xl text-white text-center transition-colors duration-200 group-hover:text-blue-400">
                  {group.name}
                </h3>
              </motion.div>
            </Link>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default KolektifGroups;
